import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SyncIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M22 2a1 1 0 1 0-2 0v3.755l-1.331-1.198-.002-.002A10 10 0 0 0 2 11.999a1 1 0 1 0 2 .002 8 8 0 0 1 13.332-5.957l.001.001L18.394 7H15a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V2ZM2 16a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H5.606l1.06.955h.002A8 8 0 0 0 20 12a1 1 0 0 1 2 .002 9.999 9.999 0 0 1-16.667 7.444l-.002-.002L4 18.245V22a1 1 0 1 1-2 0v-6Z" />
  </Icon>
));
export default SyncIcon;
